import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

interface TaskAction extends Action {
    payload: {
        groupId: string
    }
}

const { onRequest, onSuccess, onFailure } = rootActions.group.one
function* oneGroupTaskSaga({ payload }) {
    try {
        const response = yield axios.get(`/companies/group/one/${payload.groupId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* oneGroupSaga(): any {
    yield takeLatest<TaskAction>(onRequest, oneGroupTaskSaga)
}

export default oneGroupSaga
